import React, {Component} from 'react';
import {Button, Layout, Typography, Card} from "antd";
import OpenSheetMusicDisplay from "../../components/OpenSheetMusicDisplay";
import {StopOutlined} from '@ant-design/icons';
import {
    drawExercise,
    noteValues,
    playCorrect,
    playIncorrect
} from "./helper";
import {MusicXml} from "./MusicXml";

const {Content} = Layout;

const exercises = noteValues.filter(noteValue => noteValue);

export default class NoteValuesTestContainer extends Component {

    state = {
        current: null,
        result: 0,
        exerciseNo: 0
    }

    start() {
        this.setState({current: drawExercise(exercises)});
    }

    stop() {
        this.setState({current: null, exerciseNo: 0, result: 0});
    }

    check(value) {
        let {result, exerciseNo} = this.state;
        if (this.state.current.name === value.name) {
            playCorrect();
            result++;
        } else {
            playIncorrect();
            alert('Prawidłowa odpowiedź to: ' + this.state.current.name);
        }
        exerciseNo++;
        this.setState({result, exerciseNo, current: drawExercise(exercises)});
    }

    render() {
        return <Layout style={{background: '#fff', margin: '0 24px', padding: '0'}}>
            <Content style={{padding: '20px'}}>
                <div style={{textAlign: 'left'}}>
                    <Typography.Title level={3} style={{textTransform: 'uppercase', margin: '0'}}>
                        Wartości rytmiczne. Test
                    </Typography.Title>

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '10px',
                        justifyContent: 'center',
                        marginTop: '20px'
                    }}>

                        {
                            this.state.current ?
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <Card title={'Wynik'} style={{
                                        width: '250px',
                                        fontSize: '36px',
                                        textAlign: 'center',
                                        fontWeight: 'bold'
                                    }}
                                          bordered={true}
                                    >
                                        {this.state.result} / {this.state.exerciseNo}
                                    </Card>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '5px'
                                    }}>
                                        <Typography.Title level={4} style={{margin: '0'}}>
                                            Jaka to wartość rytmiczna?
                                        </Typography.Title>
                                        <div style={{width: '300px'}}>
                                            <OpenSheetMusicDisplay
                                                file={MusicXml.buildNoteValueMusicXML(this.state.current)}
                                                drawTitle={false}
                                                autoResize={true}
                                                backend={'svg'}
                                                drawPartNames={false}
                                                drawCredits={false}
                                                drawTimeSignatures={false}
                                                stretchLastSystemLine={true}
                                            />
                                        </div>
                                        <Button icon={<StopOutlined/>}
                                                onClick={() => this.stop()}>
                                            Zakończ
                                        </Button>
                                    </div>
                                    <p style={{marginTop: '10px'}}>Wskaż prawidłową odpowiedź:</p>
                                    <div style={{
                                        padding: '10px 10px',
                                        display: 'flex',
                                        gap: '10px',
                                        flexWrap: 'wrap',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        {
                                            noteValues.map(item => (
                                                <Card key={item.name}
                                                      style={{width: '200px', fontSize: '14px', textAlign: 'center'}}
                                                      hoverable={true}
                                                      bordered={true}
                                                      onClick={() => this.check(item)}
                                                >
                                                    {item.name}
                                                </Card>
                                            ))
                                        }
                                    </div>
                                </div> :
                                <Button type="primary"
                                        onClick={() => this.start()}>
                                    Start
                                </Button>
                        }
                    </div>
                </div>
            </Content>
        </Layout>
    }
}
